import Page from './page';

export default class InitialOrderProductDetailsPage extends Page {
  constructor() {
    super(true);
  }

  init(): void {
    super.init();
  }
}
